var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldSelect } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
const timezones = moment.tz.names();
const formattedTimezones = timezones.map((timezone) => {
    const offset = moment.tz(timezone).format('Z');
    return {
        id: timezone,
        name: `${timezone} (${offset})`,
    };
});
export const TimezoneSelector = (_a) => {
    var { className, input, label, meta, placeholder, required } = _a, rest = __rest(_a, ["className", "input", "label", "meta", "placeholder", "required"]);
    return (_jsx(FieldSelect, Object.assign({ className: className, input: input, items: formattedTimezones, label: label || 'Timezone', meta: meta, placeholder: placeholder, required: required, searchable: true }, rest)));
};
